/* eslint-disable jsx-a11y/alt-text */
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
} from "@mui/material";
import { motion } from "framer-motion";
import HeaderUK from "../Images/Offices/flagUKk.jpg";
import erbil from "../Images/Offices/sarakiUK.jpg";
import dhouk from "../Images/Offices/dwamUK.jpg";
import Icon from "../Offices/MapOffices/Image/marker-icon.png";
import "../Styles/UKoffice.css";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MapUK from "./MapOffices/MapUK";
import ContactChat from "../Hellper/ContactChat";

const UKOffices = () => {
  const fadeInVariant = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 1 },
  };
  const listItemVariant = {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0 },
    transition: { duration: 0.5, delay: 0.2 },
  };
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        textAlign: "center",
        marginTop: "60px",
      }}
    >
      <header className="new-page-header">
        <img src={HeaderUK} alt="Header" className="new-page-image" />
      </header>

      {/* Offices Grid */}
      <Grid
        container
        spacing={4} // Consistent spacing between items
        sx={{
          mt: 4, // Margin top for the Grid container
          marginBottom: 4, // Margin bottom for the Grid container
          padding: "0 16px", // Padding to prevent overflow
          justifyContent: "center", // Center the grid items
        }}
      >
        {/* Erbil Office */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card
            sx={{
              maxWidth: "100%", // Make the card responsive
              boxShadow: 4,
              height: "100%", // Ensure all cards have the same height
              display: "flex",
              flexDirection: "column",
              marginBottom: 2, // Add margin bottom to the card
            }}
          >
            <motion.div {...listItemVariant}>
              <CardMedia
                component="img"
                alt="Erbil"
                height="200"
                image={erbil}
                sx={{
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "8px",
                }}
              />
            </motion.div>
            <motion.div {...fadeInVariant}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  UK Head Office
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", mb: 1 }}
                >
                  Address:15, Little Balmer, Buckingham Industrial Estate,
                  Buckingham, MK18 1TF{" "}
                  <a
                    href="https://www.google.com/maps?q=UK+TO+MARS+LTD,+Buckingham+Industrial+Estate,+15+Little+Balmer,+Buckingham+MK18+1TF&ftid=0x4876e328e06e04cf:0xcc8306166b41f179&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_ep=CAISEjI0LjQ5LjMuNzAyODc2MTUxMBgAINeCAypjLDk0MjI0ODI1LDk0MjI3MjQ3LDk0MjI3MjQ4LDk0MjMxMTg4LDQ3MDcxNzA0LDQ3MDY5NTA4LDk0MjE4NjQxLDk0MjAzMDE5LDQ3MDg0MzA0LDk0MjA4NDU4LDk0MjA4NDQ3QgJHQg%3D%3D&g_st=com.google.maps.preview.copy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={Icon}
                      width={15}
                      height={15}
                      alt="Location Icon"
                    />
                  </a>
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Email: admin@uktomars.co.uk
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Email: sales@uktomars.co.uk
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Tel:+44 7564 627910
                </Typography>
              </CardContent>
            </motion.div>
          </Card>
        </Grid>

        {/* Dhouk Office */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card
            sx={{
              maxWidth: "100%",
              boxShadow: 4,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              marginBottom: 2, // Add margin bottom to the card
            }}
          >
            <motion.div {...listItemVariant}>
              <CardMedia
                component="img"
                alt="Dhouk"
                height="200"
                image={dhouk}
                sx={{
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "8px",
                }}
              />
            </motion.div>
            <motion.div {...fadeInVariant}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  Coventry
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", mb: 1 }}
                >
                  Address: 316, Foleshill Road, CV6 5AJ
                  <a
                    href="https://www.google.com/maps?q=316+Foleshill+Rd,+Foleshill,+Coventry+CV6+5AJ&ftid=0x48774bf2aeb490d1:0xc95afa324ca94f94&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_st=com.google.maps.preview.copy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={Icon}
                      width={15}
                      height={15}
                      alt="Location Icon"
                    />
                  </a>
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Email: info@uktomars.co.uk
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Tel:+44 7477 239098
                </Typography>
              </CardContent>
            </motion.div>
          </Card>
        </Grid>
      </Grid>

      {/* Map Section */}
      <Box sx={{ marginTop: 4, marginBottom: 4 }}>
        <MapUK />
      </Box>

      {/* Contact Chat Section */}
      <Box sx={{ marginTop: 4, marginBottom: 4 }}>
        <ContactChat />
      </Box>
    </Box>
  );
};

export default UKOffices;
